import { render, staticRenderFns } from "./DeactivateDisplayBlock.vue?vue&type=template&id=fec2af8e&scoped=true&"
import script from "./DeactivateDisplayBlock.vue?vue&type=script&lang=js&"
export * from "./DeactivateDisplayBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateDisplayBlock.vue?vue&type=style&index=0&id=fec2af8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec2af8e",
  null
  
)

export default component.exports